import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ReactTable from 'react-table';
import { withState } from 'recompose';

import Date from '../../../common/date';
import Time from '../../../common/Time';
import Money from '../../../common/money';
import RowExpanded from './SummaryRowExpanded';
import { MAX_SUMMARY_ENTRIES } from '../constants';
import { getSubTableColumns, isRefunded } from './utils';
import { fullName } from '../../../common/helpers/users';

export const SaleBarberName = ({ value, original }) => (
  <div>
    {value}
    <span display-if={original.appointmentTime}>&nbsp;-&nbsp;
      <Date>{original.appointmentTime}</Date>
      @
      <Time>{original.appointmentTime}</Time>
    </span>
  </div>
);
SaleBarberName.propTypes = {
  value: PropTypes.string.isRequired,
  original: PropTypes.object.isRequired,
};

export const SaleTotalCharge = ({ value, original }) => (
  <div className={classnames({ 'u-co-red': isRefunded(original) || value <= 0 })}>
    <Money automationId="text:saleTotalCharge">{isRefunded(original) ? 0 : value}</Money>
  </div>
);
SaleTotalCharge.propTypes = {
  value: PropTypes.number.isRequired,
  original: PropTypes.object.isRequired,
};

export const SaleCustomer = ({ value }) => (
  <div className="u-pre-wrap">
    {fullName(value)}
  </div>
);
SaleCustomer.propTypes = {
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
};

const SubSummaryTable = ({ collapseAll, expanded, items, setExpanded, onItemClick }) => {
  const expandedRows = collapseAll ? {} : expanded;

  return (
    <ReactTable
      defaultPageSize={MAX_SUMMARY_ENTRIES}
      showPagination={false}
      defaultSorted={[{ id: 'time' }]}
      minRows={0}
      TheadComponent={() => null}
      className="ReactTable--row-spacing-only c-summary-table"
      data={items}
      expanded={expandedRows}
      getTrGroupProps={(state, rowInfo) => ({
        className: classnames('is-clickable', {
          'is-active': expandedRows[rowInfo.viewIndex],
        }),
      })}
      getTrProps={(state, rowInfo) => ({
        onClick: () => {
          setExpanded({
            [rowInfo.viewIndex]: !expandedRows[rowInfo.viewIndex],
          });
          onItemClick(rowInfo);
        },
      })}
      SubComponent={({ original }) => <RowExpanded item={original} />}
      columns={getSubTableColumns()}
    />
  );
};

SubSummaryTable.propTypes = {
  items: PropTypes.array.isRequired,
  expanded: PropTypes.object.isRequired,
  setExpanded: PropTypes.func.isRequired,
  onItemClick: PropTypes.func.isRequired,
  collapseAll: PropTypes.bool,
};

SubSummaryTable.defaultProps = {
  collapseAll: false,
};

export const SubSummary = withState('expanded', 'setExpanded', {})(SubSummaryTable);
